import {Controller} from "@hotwired/stimulus"
import {useIntersection} from "stimulus-use";

export default class extends Controller {
    connect() {
        useIntersection(this, {
            rootMargin: "100px",
        });
    }

    appear() {
        this.loadMore('https://example.com/more');
    }

    loadMore() {
        const colspan = this.element.dataset.colspan
        let html = ""
        for (let i = 0; i < colspan; i++) {
            html += `<td class="animate-pulse"><div class="px-4 py-3 bg-gray-200 rounded-lg m-2 h-10"></div></td>`;
        }
        var parentElement = this.element.parentElement
        var url = this.element.dataset.url
        const newUrl = new URL(window.location.origin + url)
        var offset = this.element.dataset.offset
        var total = this.element.dataset.total
        var tr = document.querySelector(`tr[data-id="loader"]`);
        if (this.parseInteger(total) > this.parseInteger(offset)) {
            newUrl.searchParams.set("offset", offset)
            fetch(newUrl)
                .then(response => response.text())
                .then(html => {
                    parentElement.outerHTML = html
                    tr.classList.add('hidden')
                })
            parentElement.innerHTML = html
            tr.classList.remove('hidden')
        }
    }

    parseInteger(value) {
        const parsedValue = parseInt(value);
        return isNaN(parsedValue) ? 0 : parsedValue;
    }

}
